"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTextArea = exports.useTextFormatter = exports.useTextField = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
function useTextInput(initialState, max, customTextValidation) {
    const [value, setValue] = react_1.default.useState(initialState);
    const onChange = react_1.default.useCallback((e) => setValue(e.target.value), [setValue]);
    const onClear = react_1.default.useCallback(() => setValue(''), [setValue]);
    const { message, valid } = customTextValidation ? customTextValidation(value, max) : (0, widgets_1.getMaxCharValidation)(value, max);
    return { value, onChange, onClear, valid, message };
}
function useTextField(_a) {
    var { initialState, max, customTextValidation } = _a, props = tslib_1.__rest(_a, ["initialState", "max", "customTextValidation"]);
    const { value, onChange, onClear, valid, message } = useTextInput(initialState, max, customTextValidation);
    const element = (react_1.default.createElement(widgets_1.TextFieldWidget, Object.assign({}, props, { value: value, onChange: onChange, onClear: onClear, valid: valid, message: message })));
    return { value, valid, reset: onClear, element };
}
exports.useTextField = useTextField;
function useTextFormatter(_a) {
    var { initialState, max, customTextValidation } = _a, props = tslib_1.__rest(_a, ["initialState", "max", "customTextValidation"]);
    const { value, onChange, onClear, valid, message } = useTextInput(initialState, max, customTextValidation);
    const element = react_1.default.createElement(widgets_1.TextFormatterWidget, Object.assign({}, props, { markup: value, onChange: onChange, valid: valid, message: message }));
    return { value, valid, reset: onClear, element };
}
exports.useTextFormatter = useTextFormatter;
function useTextArea(_a) {
    var { initialState, max, customTextValidation } = _a, props = tslib_1.__rest(_a, ["initialState", "max", "customTextValidation"]);
    const { value, onChange, onClear, valid, message } = useTextInput(initialState, max, customTextValidation);
    const element = react_1.default.createElement(widgets_1.TextAreaWidget, Object.assign({}, props, { value: value, onChange: onChange, valid: valid, message: message }));
    return { value, valid, reset: onClear, element };
}
exports.useTextArea = useTextArea;
//# sourceMappingURL=useTextInput.js.map